export const LOADING_REQUEST = "LOADING_REQUEST";
export const LOADING_SUCCESS = "LOADING_SUCCESS";

export const RESUME_LOADING_REQUEST = "RESUME_LOADING_REQUEST";
export const RESUME_LOADING_SUCCESS = "RESUME_LOADING_SUCCESS";

export const EDITOR_LOADING_REQUEST = "EDITOR_LOADING_REQUEST";
export const EDITOR_LOADING_SUCCESS = "EDITOR_LOADING_SUCCESS";
export const EDITOR_LOADING_FAIL = "EDITOR_LOADING_FAIL";
